import './App.css';
import ReactGA from "react-ga4";

import {
  BrowserRouter,
  Route,
  Routes
} from "react-router-dom";

import Archive from "./components/Archive";
import ComicContainer from "./components/ComicContainer";
import Contact from "./components/Contact";
import FAQ from "./components/FAQ";
import Homepage from "./components/Homepage";
import LeftSide from "./components/LeftSide";
import TopArea from "./components/TopArea";
import NewsPage from "./components/NewsPage";

ReactGA.initialize("G-N39FWYZ398");

function App() {
  return (
    <BrowserRouter>
        <TopArea />
        <div id="container">
          <LeftSide />
          <div id="main_content">
            <Routes>
              <Route path={"/"} element={<Homepage />} />
              <Route path={"/index.html"} element={<Homepage />} />
              <Route path={"/news/:newsId"} element={<NewsPage />} />
              <Route path={"/news"} element={<Homepage />} />
              <Route path={"/faq"} element={<FAQ />} />
              <Route path={"/contact"} element={<Contact />} />
              <Route path={"/hoh/:char/archive"} element={<Archive story={"hoh"} />} />
              <Route path={"/hoh/:char/:comic"} element={<ComicContainer story={"hoh"} />} />
              <Route path={"/hoh/archive"} element={<Archive story={"hoh"} />} />
              <Route path={"/hoh/:comic"} element={<ComicContainer story={"hoh"} />} />
              <Route path={"/aptgg/:char/archive"} element={<Archive story={"aptgg"} />} />
              <Route path={"/aptgg/:char/:comic"} element={<ComicContainer story={"aptgg"} />} />
              <Route path={"/aptgg/archive"} element={<Archive story={"aptgg"} />} />
              <Route path={"/aptgg/:comic"} element={<ComicContainer story={"aptgg"} />} />
            </Routes>
          </div>
        </div>
    </BrowserRouter>
  );
}

export default App;
